import { render, staticRenderFns } from "./ProceedingForm.vue?vue&type=template&id=6b0bfff3&scoped=true"
import script from "./ProceedingForm.vue?vue&type=script&lang=js"
export * from "./ProceedingForm.vue?vue&type=script&lang=js"
import style0 from "./ProceedingForm.vue?vue&type=style&index=0&id=6b0bfff3&prod&lang=css&scoped=true"
import style1 from "./ProceedingForm.vue?vue&type=style&index=1&id=6b0bfff3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0bfff3",
  null
  
)

export default component.exports